/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Uploading_FramesInputs */

const en_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading frames (${i?.completed}/${i?.total})...`)
};

const fr_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chargement des images (${i?.completed}/${i?.total})...`)
};

const de_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frames werden hochgeladen (${i?.completed}/${i?.total})...`)
};

const it_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caricamento dei frame (${i?.completed}/${i?.total})...`)
};

const ru_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загрузка кадров (${i?.completed}/${i?.total})...`)
};

const es_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subiendo fotogramas (${i?.completed}/${i?.total})...`)
};

const zh_cn2_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在上传帧（${i?.completed}/${i?.total}）...`)
};

const ja_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームをアップロード中（${i?.completed}/${i?.total}）...`)
};

const hi_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ़्रेम अपलोड किए जा रहे हैं (${i?.completed}/${i?.total})...`)
};

const pt_pt2_uploading_frames = /** @type {(inputs: Uploading_FramesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carregando frames (${i?.completed}/${i?.total})...`)
};

/**
* | output |
* | --- |
* | "Uploading frames ({completed}/{total})..." |
*
* @param {Uploading_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_frames = /** @type {((inputs: Uploading_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_uploading_frames(inputs)
	if (locale === "de") return de_uploading_frames(inputs)
	if (locale === "it") return it_uploading_frames(inputs)
	if (locale === "ru") return ru_uploading_frames(inputs)
	if (locale === "es") return es_uploading_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_uploading_frames(inputs)
	if (locale === "ja") return ja_uploading_frames(inputs)
	if (locale === "hi") return hi_uploading_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_uploading_frames(inputs)
	return en_uploading_frames(inputs)
});